import L from "../../../assets/svg/CheckmarkCircle/CheckmarkCircle.js";
import { cn as s } from "../../../lib/shadcn/utils/utils.js";
import { GeneralKeys as h } from "../../../i18n/translations/types/general.js";
import { Namespace as T } from "../../../i18n/translations/types/namespaces.js";
import U from "../../../assets/svg/Close/Close.js";
import W from "../../../assets/svg/DeleteDisableHexagon/DeleteDisableHexagon.js";
import q from "../../../assets/svg/Information/Information.js";
import z from "../../../assets/svg/Warning/Warning.js";
import { Button as t } from "../../ui/Button/Button.js";
import { Card as D } from "../../ui/Card/Card.js";
import V from "../../../assets/svg/ArrowDown/ArrowDown.js";
import I from "../../../assets/svg/ArrowUp/ArrowUp.js";
import J from "../../../assets/svg/Export/Export.js";
import { useMemo as x, useState as O } from "react";
import { Fragment as P, jsx as r, jsxs as c } from "react/jsx-runtime";
import { useTranslation as Q } from "react-i18next";
import { cva as g } from "class-variance-authority";
var R = g("box-border flex w-full flex-row items-start justify-start gap-2 gap-4 rounded-md border border-solid p-4 text-caption-2", {
  variants: { variant: {
    info: "border-info-400 bg-info-50 text-info-800 [&_a]:text-primary-700",
    warning: "border-warn-800 bg-warn-100 text-warn-800",
    error: "border-error-800 bg-error-200 text-error-800",
    success: "border-success-500 bg-success-100 text-success-800",
    danger: "border-primary-100! bg-primary-100 text-secondary-900"
  } },
  defaultVariants: { variant: "info" }
}), a = g("h-6 w-6 min-w-6 [&_*]:stroke-[1.5]", {
  variants: { variant: {
    info: "[&_*]:stroke-info-800",
    warning: "[&_*]:stroke-warn-800",
    error: "[&_*]:stroke-error-800",
    success: "[&_*]:stroke-success-800",
    danger: "[&_*]:stroke-secondary-900"
  } },
  defaultVariants: { variant: "info" }
}), E = g("flex flex-col items-start justify-start pt-4 text-caption-1", {
  variants: { variant: {
    info: "text-info-800",
    warning: "text-warn-800",
    error: "text-error-800",
    success: "text-success-800",
    danger: "text-secondary-900"
  } },
  defaultVariants: { variant: "info" }
}), o = g("uppercase no-underline", {
  variants: { variant: {
    info: "text-info-800",
    warning: "text-warn-800",
    error: "text-error-800",
    success: "text-success-800",
    danger: "text-secondary-900"
  } },
  defaultVariants: { variant: "info" }
}), ue = ({ id: M, variant: e, title: k, description: v, collapsible: b, extraDetails: l, action1: m, action2: f, action3: d, action4: u, showCloseButton: y, mode: n, className: B, dataTestid: G, hideIcon: A, onAction: p, onClose: F }) => {
  const { t: N } = Q(T.General), [i, C] = O(!1), S = x(() => !!(m || f || d || u), [
    m,
    f,
    d,
    u
  ]), H = x(() => {
    switch (e) {
      case "warning":
        return /* @__PURE__ */ r(z, { className: a({ variant: e }) });
      case "error":
        return /* @__PURE__ */ r(W, { className: a({ variant: e }) });
      case "success":
        return /* @__PURE__ */ r(L, { className: a({ variant: e }) });
      case "danger":
        return /* @__PURE__ */ r(J, { className: a({ variant: e }) });
      default:
        return /* @__PURE__ */ r(q, { className: a({ variant: e }) });
    }
  }, [e]), _ = x(() => /* @__PURE__ */ c(P, { children: [" ", S && /* @__PURE__ */ c("div", {
    className: s("flex flex-row gap-2", { "pt-4": n !== "snackbar" }),
    children: [
      m && /* @__PURE__ */ r(t, {
        name: "notification-action-1",
        variant: "link",
        className: s(o({ variant: e }), "self-start"),
        onClick: () => p?.(1),
        children: m
      }),
      f && /* @__PURE__ */ r(t, {
        name: "notification-action-2",
        variant: "link",
        className: s(o({ variant: e }), "self-start"),
        onClick: () => p?.(2),
        children: f
      }),
      /* @__PURE__ */ r("div", { className: "flex min-h-1 w-full" }),
      d && /* @__PURE__ */ r(t, {
        name: "notification-action-3",
        variant: "link",
        className: s(o({ variant: e }), "self-end"),
        onClick: () => p?.(3),
        children: d
      }),
      u && /* @__PURE__ */ r(t, {
        name: "notification-action-4",
        variant: "link",
        className: s(o({ variant: e }), "self-end"),
        onClick: () => p?.(4),
        children: u
      })
    ]
  })] }), [
    S,
    m,
    f,
    d,
    u
  ]), j = e === "error" || e === "warning" || e === "danger" ? "alert" : "status", K = j === "alert" ? "assertive" : "polite", w = x(() => n === "inline" || n === "snackbar", [n]);
  return /* @__PURE__ */ c(D, {
    id: M,
    name: "notification-card",
    dataTestid: G,
    className: s(R({ variant: e }), B),
    role: j,
    "aria-live": K,
    "aria-atomic": "true",
    children: [
      !A && /* @__PURE__ */ r("div", {
        className: s("flex h-full flex-col items-center justify-start", { "self-center": n === "snackbar" }),
        children: H
      }),
      /* @__PURE__ */ c("div", {
        className: s("flex w-full flex-col"),
        children: [
          k && /* @__PURE__ */ r("p", {
            className: s("m-0 text-body-1"),
            children: k
          }),
          v && /* @__PURE__ */ r("div", {
            className: s("m-0"),
            children: b && l && i ? l : v
          }),
          !w && _,
          b && l ? /* @__PURE__ */ r("div", {
            className: E({ variant: e }),
            children: /* @__PURE__ */ r(t, {
              name: "notification-show-more",
              variant: "link",
              className: s("text-caption-1", o({ variant: e }), "normal-case"),
              endIcon: i ? /* @__PURE__ */ r(I, { className: a({ variant: e }) }) : /* @__PURE__ */ r(V, { className: a({ variant: e }) }),
              onClick: () => C(!i),
              children: N(h.Notification_ShowMore)
            })
          }) : l && /* @__PURE__ */ c("div", {
            className: E({ variant: e }),
            children: [/* @__PURE__ */ r(t, {
              name: "notification-show-more",
              variant: "link",
              className: s("text-caption-1", o({ variant: e }), "normal-case"),
              endIcon: i ? /* @__PURE__ */ r(I, { className: a({ variant: e }) }) : /* @__PURE__ */ r(V, { className: a({ variant: e }) }),
              onClick: () => C(!i),
              children: N(h.Notification_ShowMore)
            }), i && /* @__PURE__ */ r("div", {
              className: s("pt-2 text-caption-2"),
              children: l
            })]
          })
        ]
      }),
      (y || w) && /* @__PURE__ */ c("div", {
        className: s("flex items-end justify-start", {
          "flex-col justify-start": n === "inline",
          "flex-row-reverse items-center justify-center gap-2 self-center": n === "snackbar"
        }),
        children: [y && /* @__PURE__ */ r(t, {
          name: "notification-close",
          variant: "link",
          className: s(o({ variant: e }), "h-6 w-6"),
          onClick: () => F?.(),
          "aria-label": N(h.Close),
          children: /* @__PURE__ */ r(U, { className: a({ variant: e }) })
        }), w && _]
      })
    ]
  });
};
export {
  ue as Notification
};

//# sourceMappingURL=Notification.js.map